<template>
    <v-layout
        row
        :style="maxWidth"
    >
        <v-flex
            class="ml-3"
            :style="maxWidth"
        >
            <breadcrumbs
                :items="breadcrumbsItems"
            ></breadcrumbs>
            <v-card
                class="ma-3 col-sm-6" outlined
            >
            <v-card-title>Edit Service</v-card-title>
            <div class="col">
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                >
                    <v-text-field
                        disabled
                        label="Outlet"
                        v-model="outlet.name"
                    ></v-text-field>

                    <v-text-field
                        v-model="service.name"
                        :rules="nameRules"
                        label="Name *"
                        autocomplete="off"
                        required
                    ></v-text-field>

                    <v-text-field
                        v-model="service.description"
                        label="Description"
                        autocomplete="off"
                    ></v-text-field>

                    <div class="pt-3 pl-3 pb-1">
                        <v-row>
                            <v-label class="mt-5">Operation Times</v-label>
                            <v-btn
                                class="ml-2"
                                x-small
                                color="success"
                                @click="timesDialog = true"
                            >
                                +
                            </v-btn>
                        </v-row>
                        <div v-if="operationTimes.length > 0">
                            <v-label>Operation:</v-label>
                            <v-row class="pa-3">
                                <v-row>
                                    <v-col class="pt-0 pb-0" cols="12" v-for="(ot) in operationTimes" :key="ot.id">
                                        <v-input
                                            append-icon="close"
                                            background-color="#E3F2FD"
                                        >
                                            {{ convertDayName(ot.day) }} <br> {{ ot.time }}
                                            <template slot="append" v-if="ot.timeslots">
                                                <v-btn @click="timeslotLimit(ot.id)" color="primary" class="font-weight-bold">Set Limit
                                                </v-btn>
                                            </template>
                                            <template slot="append" v-else>
                                                <span style="font-size: small"> Please set interval and limit per interval to generate time slot</span>
                                            </template>
                                            <template slot="append">
                                                <v-icon @click="removeOperationTime(ot)">close</v-icon>
                                            </template>
                                        </v-input>
                                    </v-col>
                                </v-row>
                            </v-row>
                        </div>
                        <div v-if="breakTimes.length > 0">
                            <v-label>Break:</v-label>
                            <v-row class="pa-3">
                                <v-input
                                    v-for="(bt) in breakTimes"
                                    append-icon="close"
                                    :key="bt.id"
                                    background-color="#F5F5F5"
                                    @click:append="removeOperationTime(bt)"
                                >
                                    {{ convertDayName(bt.day) }} <br> {{ bt.time }}
                                </v-input>
                            </v-row>
                        </div>
                    </div>

                    <v-text-field
                        v-model="service.interval"
                        label="Interval(minutes)"
                        autocomplete="off"
                    ></v-text-field>

                    <v-text-field
                        v-model="service.prefix"
                        label="Prefix"
                        autocomple="off"
                    >
                    </v-text-field>

                    <v-text-field
                        v-model="service.queue_no_digit"
                        label="Queue No Digit"
                        autocomplete="off"
                        type="number"
                        persistent-hint
                        hint="e.g.: set this value to 3, queue no format will be 001"
                    ></v-text-field>

                    <v-btn
                        :disabled="!valid"
                        color="success"
                        class="mt-4 mr-4 font-weight-bold"
                        @click="submit"
                    >
                        Save
                    </v-btn>
                </v-form>
            </div>
        </v-card>

        <v-dialog
            v-model="timesDialog"
            width="400"
        >
            <v-card>
            <v-row>
            <v-col>
            <v-card-title>Operation Time</v-card-title>
            </v-col>
            <v-col>
                <v-btn class="text-right float-right" text @click="timesDialog = !timesDialog">X</v-btn>
            </v-col>
            </v-row>
                <v-radio-group class="mt-0 pa-4" v-model="type" :mandatory="false" row>
                    <v-radio label="Operation" value="operation" @change="changeDay('all')"></v-radio>
                    <v-radio label="Break" value="break" @change="changeDay('break')"></v-radio>
                </v-radio-group>
                <v-select
                    :items="days"
                    :item-text="days.name"
                    label="Day"
                    v-model="day"
                    multiple
              outlined
              class="mr-0 pl-4 col-11"
                ></v-select>
                <v-text-field
                    v-model="time"
                    label="Time"
                    placeholder="e.g: 1300-1500"
                    autocomplete="off"
              outlined
              class="mr-0 pl-4 col-11"
                ></v-text-field>
          <v-btn @click="addTime" class="font-weight-bold ml-4 mb-4" color="success">Save</v-btn>
            </v-card>
        </v-dialog>
        </v-flex>
    </v-layout>
</template>

<script>
import axios from 'axios'

export default {
    data: () => ({
        valid: true,
        nameRules: [
            v => !!v || 'Name is required',
        ],
        timesDialog: false,
        type: 'operation',
        day: null,
        time: null,
        days: [],
        breakDays: '',
        daySelection: [
            {text: 'Sunday', value: 0},
            {text: 'Monday', value: 1},
            {text: 'Tuesday', value: 2},
            {text: 'Wednesday', value: 3},
            {text: 'Thursday', value: 4},
            {text: 'Friday', value: 5},
            {text: 'Saturday', value: 6}
        ],
        breakTimes: [],
        operationTimes: [],
        breadcrumbsItems: '',
    }),
    props: ['outlet', 'service'],
    computed: {
        maxWidth() {
            return {
                maxWidth: window.outerWidth + 'px'
            }
        }
    },
    methods: {
        submit() {
            const prefix = '/outlet/' + this.outlet.id;
            if (this.$refs.form.validate()) {
                axios.post(prefix + '/service/' + this.service.id, {
                    name: this.service.name,
                    description: this.service.description,
                    active: this.service.active,
                    interval: this.service.interval,
                    limit: this.service.limit,
                    // counter_no: this.service.counter_no,
                    message: this.service.message,
                    prefix: this.service.prefix,
                    queue_no_digit: this.service.queue_no_digit,
                }).then(result => {
                    swal({
                        title: 'Service updated!',
                        buttons: false,
                        timer: 3000,
                        icon: "success"
                    }).then(function () {
                        window.location.reload()
                        window.scrollTo(0, 0)
                    })
                });
            }
        },
        addTime() {
            axios.post('/operation_times', {
                days: this.day,
                time: this.time,
                type: this.type,
                model_id: this.service.id,
                model_type: 'App\\Service'
            }).then(response => {
                response.data.type === 'operation' ? this.operationTimes.push(response.data) : this.breakTimes.push(response.data);
                if (response.data.type === 'operation') this.breakDays += response.data.day;
                let bd = '';
                this.operationTimes.forEach(function (t, idx, array) {
                    if (idx !== array.length - 1) {
                        bd += t.day + ','
                    } else {
                        bd += t.day
                    }
                });
                this.breakDays = bd;
                // reset value
                this.type = 'operation';
                this.day = null;
                this.time = null;
                this.timesDialog = false;
            })
        },
        manageService(id) {
            window.location.href = '#'
        },
        removeOperationTime(t) {
            // axios to remove operation time
            let type = t.type;
            const i = type === 'operation' ? this.operationTimes.indexOf(t) : this.breakTimes.indexOf(t);
            axios.delete('/operation_times/' + t.id).then(response => {
                type === 'operation' ? this.operationTimes.splice(i, 1) : this.breakTimes.splice(i, 1);
            });
        },
        createService() {
            window.location.href = '#'
        },
        convertDayName(day) {
            let dayName = '';
            let d2 = day.split(",");
            this.daySelection.forEach(function (d) {
                d2.forEach(function (x, index, array) {
                  if (d.value === parseInt(x)) {
                    if (index === array.length - 1) {
                      dayName += d.text
                    } else {
                      dayName += d.text + ', '
                    }
                  }
                })
            });
            return dayName;
        },
        changeDay(type) {
            if (type === 'all') this.days = this.daySelection;
            if (type === 'break') {
                let b = this.breakDays;
                let result = [];
                this.daySelection.forEach(function (d) {
                    if (b.includes(d.value)) result.push(d);
                });
                this.days = result;
            }
        },
    },
    beforeMount() {
        axios.get('/api/operation_times/model?type=operation&sid=' + this.service.id).then(response => {
            this.operationTimes = response.data;
            let bd = '';
            response.data.forEach(function (t, idx, array) {
                if (idx !== array.length - 1) {
                    bd += t.day + ','
                } else {
                    bd += t.day
                }
            });
            this.breakDays = bd;
        });
        axios.get('/api/operation_times/model?type=break&sid=' + this.service.id).then(response => {
            this.breakTimes = response.data
        });
        this.days = this.daySelection;
        this.breadcrumbsItems = [
            {
                disabled: false,
                href: '/',
                link: true,
                text: 'Home',
            },
            {
                disabled: false,
                href: '/outlet/' + this.outlet.id + '/edit',
                link: true,
                text: this.outlet.name,
            },
            {
                disabled: true,
                href: '#',
                link: true,
                text: this.service.name,
            },
        ];
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Services/ServiceEdit.vue